import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="analytics"
// Fires a GA4 `store_click` event when a store badge is clicked.
export default class extends Controller {
  static values = { store: String, placement: String }

  track() {
    if (typeof window.gtag !== "function") return

    window.gtag("event", "store_click", {
      store: this.storeValue,
      placement: this.placementValue,
    })
  }

  // Fires a GA4 `sign_up_start` event when a landing signup form is submitted.
  signupStart() {
    if (typeof window.gtag !== "function") return

    window.gtag("event", "sign_up_start", { placement: this.placementValue })
  }
}
